import { render, staticRenderFns } from "./CardTestimony.vue?vue&type=template&id=5a2b9d6a&"
import script from "./CardTestimony.vue?vue&type=script&lang=js&"
export * from "./CardTestimony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports